module.exports = __webpack_public_path__ + "static/img/wood72.b499960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood72.jpg
// module id = OVJh
// module chunks = 0